import { useMutation } from "react-query";
import { updateGuide } from "~/components/Forms/DealerPassportForm2/requests/updateGuide";

export default function useUpdateGuide() {
  return useMutation({
    mutationFn: ({ dealerId, data }: { dealerId: string; data: any }) =>
      updateGuide(dealerId, data),
  });
}
